import { useMemo } from 'react';
import useProfile from '../../../shared/use-profile';

function useIsTenantSupport() {
  const profile = useProfile();
  const isTenantSupport = useMemo(() => {
    return !!profile?.role?.permissions?.includes('ui:tenant-support');
  }, [profile]);
  return isTenantSupport;
}

export default useIsTenantSupport;
